// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"18":"1d4eb3b9","233":"6151fd38","290":"9fbdacfe","453":"035f4892","545":"495e8072","666":"ad6508c3"}[chunkId] + ".chunk.js";
};